import { useAuth } from '@redwoodjs/auth'
import { useQuery } from '@redwoodjs/web'
import gql from 'graphql-tag'
import { useCallback } from 'react'
import { useQueryClient } from 'react-query'
import type { GetProfile } from 'types/graphql'

const QUERY_KEY = ['profile']

export const FIND_ACCOUNT_SETTINGS_QUERY = gql`
  query GetProfile($id: Int!) {
    user(id: $id) {
      id
      email
      realName
    }
    artist {
      id
      name
      slug
      location {
        city
        state
        country
      }
      image {
        src
      }
    }
  }
`
const useProfile = () => {
  const { currentUser, loading: isAuthenticating } = useAuth()

  const queryClient = useQueryClient()

  const result = useQuery<GetProfile>(FIND_ACCOUNT_SETTINGS_QUERY, {
    variables: {
      id: currentUser?.id,
    },
    queryKey: QUERY_KEY,
    // staleTime: 1000,
    enabled: !!currentUser,
  })

  const updateQueryCache = useCallback(
    (fresh: Partial<GetProfile>) => {
      queryClient.setQueryData(
        QUERY_KEY,
        (prev: GetProfile): GetProfile => ({
          user: {
            ...prev.user,
            ...fresh.user,
          },
          artist: {
            ...prev.artist,
            ...fresh.artist,
          },
        })
      )
    },
    [queryClient]
  )

  return {
    ...result,
    loading: isAuthenticating || result.loading,
    updateProfileQueryCache: updateQueryCache,
  }
}

export default useProfile
